// API URL - يجب أن يشير إلى السيرفر المنشور
const getApiUrl = () => {
    // أولوية: متغير البيئة (يُضبط عند النشر)
    if (process.env.REACT_APP_API_URL) {
        console.log('🌐 Using API from environment:', process.env.REACT_APP_API_URL);
        return process.env.REACT_APP_API_URL;
    }
    
    // في التطوير المحلي فقط
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.log('💻 Using local API:', 'http://localhost:3001/api');
        return 'http://localhost:3001/api';
    }
    
    // في الإنتاج: افترض أن السيرفر على نفس النطاق
    // إذا كان السيرفر منفصل، يجب إضافة REACT_APP_API_URL
    const productionUrl = `${window.location.origin}/api`;
    console.log('🌍 Using production API:', productionUrl);
    return productionUrl;
};

const API_URL = getApiUrl();
console.log('🔗 API URL configured:', API_URL);

// Get all pottery items
export const getPotteryItems = async () => {
    try {
        console.log('📡 Fetching from server:', API_URL);
        const response = await fetch(`${API_URL}/pottery`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            // Important: don't cache
            cache: 'no-cache'
        });
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('✅ Received items from server:', data.length);
        return data;
    } catch (error) {
        console.error('❌ getPotteryItems error:', error.message);
        console.error('⚠️ Server might be down or unreachable');
        // Only use localStorage as last resort
        const local = localStorage.getItem('potteryItems');
        if (local) {
            console.warn('📦 Using localStorage as fallback');
            return JSON.parse(local);
        }
        return [];
    }
};

// Subscribe to changes (polling)
export const subscribeToPotteryItems = (callback) => {
    let lastHash = '';
    let isActive = true;
    
    const getHash = (items) => {
        return JSON.stringify(items.map(i => ({
            id: i.id,
            price: i.price,
            titleEn: i.titleEn,
            titleAr: i.titleAr
        })).sort((a, b) => a.id.localeCompare(b.id)));
    };
    
    const checkForUpdates = async () => {
        if (!isActive) return;
        
        try {
            const items = await getPotteryItems();
            const currentHash = getHash(items);
            
            if (currentHash !== lastHash) {
                lastHash = currentHash;
                callback(items);
            }
        } catch (error) {
            console.error('Polling error:', error);
        }
    };
    
    // Initial load
    checkForUpdates();
    
    // Poll every 500ms
    const interval = setInterval(checkForUpdates, 500);
    
    return () => {
        isActive = false;
        clearInterval(interval);
    };
};

// Add item
export const addPotteryItem = async (item) => {
    try {
        console.log('📤 Adding item to server:', API_URL, item.id);
        const response = await fetch(`${API_URL}/pottery`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
        });
        
        if (!response.ok) {
            const error = await response.text();
            throw new Error(`Server error: ${response.status} - ${error}`);
        }
        
        const result = await response.json();
        console.log('✅ Item added to server:', result);
        return result;
    } catch (error) {
        console.error('❌ addPotteryItem error:', error.message);
        console.error('⚠️ Failed to add to server, using localStorage');
        // Fallback to localStorage only if server fails
        const items = JSON.parse(localStorage.getItem('potteryItems') || '[]');
        items.push(item);
        localStorage.setItem('potteryItems', JSON.stringify(items));
        return { success: true, id: item.id };
    }
};

// Update item
export const updatePotteryItem = async (itemId, item) => {
    try {
        console.log('📤 Updating item on server:', API_URL, itemId, { price: item.price });
        const response = await fetch(`${API_URL}/pottery/${itemId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
        });
        
        if (!response.ok) {
            const error = await response.text();
            throw new Error(`Server error: ${response.status} - ${error}`);
        }
        
        const result = await response.json();
        console.log('✅ Item updated on server:', result);
        return result;
    } catch (error) {
        console.error('❌ updatePotteryItem error:', error.message);
        console.error('⚠️ Failed to update on server, using localStorage');
        // Fallback to localStorage only if server fails
        const items = JSON.parse(localStorage.getItem('potteryItems') || '[]');
        const index = items.findIndex(i => i.id.toString() === itemId.toString());
        if (index !== -1) {
            items[index] = { ...item, id: itemId };
            localStorage.setItem('potteryItems', JSON.stringify(items));
        }
        return { success: true, id: itemId };
    }
};

// Delete item
export const deletePotteryItem = async (itemId) => {
    try {
        console.log('📤 Deleting item from server:', API_URL, itemId);
        const response = await fetch(`${API_URL}/pottery/${itemId}`, {
            method: 'DELETE'
        });
        
        if (!response.ok) {
            throw new Error(`Server error: ${response.status}`);
        }
        
        const result = await response.json();
        console.log('✅ Item deleted from server:', result);
        return result;
    } catch (error) {
        console.error('❌ deletePotteryItem error:', error.message);
        console.error('⚠️ Failed to delete from server, using localStorage');
        // Fallback to localStorage only if server fails
        const items = JSON.parse(localStorage.getItem('potteryItems') || '[]');
        const filtered = items.filter(i => i.id.toString() !== itemId.toString());
        localStorage.setItem('potteryItems', JSON.stringify(filtered));
        return { success: true, id: itemId };
    }
};
